import React from 'react';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { DocumentsCards } from '../../shared/document/list/DocumentsCards';
import { PsCompanyManagement } from '../../shared/model/PsCompanyManagement';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';
import { CardStorageManager } from '../../shared/utils/CardStorageManager';

export class DocumentsScreen extends React.Component {

    cardStorageManager = new CardStorageManager(this.props.location.pathname);

    constructor(props) {
        super(props);

        this.cardStorageManager.init();

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_DOCUMENTOS_DE_MIS_SUBCONTRATAS')} breadcrumbs={breadcrumbs}>
                <DocumentsCards
                    companyManagement={PsCompanyManagement.MY_OUTSOURCES}
                    saveCardState={this.saveCardState}
                    readCardState={this.readCardState}
                />
            </PsPage>
        );
    }

    saveCardState = (card, state) => {
        this.cardStorageManager.saveCard(card, state);
    };

    readCardState = (card) => {
        return this.cardStorageManager.readCard(card);
    };
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/document/DocumentsScreen.jsx